import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import PanelHeader from '../parts/PanelHeader';
import { addCommas } from '../../../utils/utils';
import { TimelineLabelType, DashboardTimelineType, OwnerType, DateRanges } from '../../../constants/ComponentTypes';
import Typography from 'material-ui/Typography';
import ArrowRight from '../../Icons/ArrowRight';
import IconButton from 'material-ui/IconButton';
import { connect } from 'react-redux';

const styles = () => ({
  root: {
    background: "#FAFAFA",
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },

  main: {
    width: '100%',
    padding: '22px 25px 32px 25px',
    background: '#FFFFFF',
    boxShadow: '0px 1px 2px #0000001F',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },

  title: {
    fontSize: '16px',
    color: '#181819',
    fontWeight: 'bold',
    paddingBottom: '9px',
    borderBottom: '1px solid #E7E9EB',
    marginBottom: '28px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },

  statusContainer: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'space-between',
  },

  header: {
    padding: '24px 28px',
    boxSizing: 'border-box',
    marginBottom: '22px',
  },

  circle: {
    display: 'flex',
    width: 30,
    height: 30,
    borderRadius: '50%',
    marginLeft: 10,
    background: '#FFFFFF',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

class StatusOverviewAbstractPanel extends React.Component {
  state = {
    dateSelected: DateRanges.PAST_1_YEAR,
    statusSelected: TimelineLabelType.APPROACH,
    filterValue: {
      created_at_from: DateRanges.PAST_1_YEAR.from,
      created_at_to: DateRanges.PAST_1_YEAR.to,
    }
  }

  componentDidMount() {
    let query = this.filterValueToQuery();
    !this.props.isDemo && this.props.getStatus({
      ...query,
    }, true);
  }

  componentDidUpdate(prevProps) {
    // 上位コンポーネントのステートによって。初期クエリ化のクエリを実行する
    if (prevProps.ownerType && prevProps.ownerType !== this.props.ownerType) {
      this.setState({
        dateSelected: DateRanges.PAST_1_YEAR,
        filterValue: { ...this.state.filterValue, ...{ 'created_at_from': DateRanges.PAST_1_YEAR.from, 'created_at_to': DateRanges.PAST_1_YEAR.to } },
      }, () => {
        let query = this.filterValueToQuery();
        this.props.getStatus({
          ...query
        }, true);
      });
    }
  }

  handleSelectDate = (item) => {
    let filterValue = {
      created_at_from: item.from ? item.from : null,
      created_at_to: item.to ? item.to : null,
    };

    this.setState({
      dateSelected: item,
      filterValue: { ...this.state.filterValue, ...filterValue },
    }, () => {
      let query = this.filterValueToQuery();

      this.props.getStatus({
        ...query
      }, true);
    });
  }

  filterValueToQuery = (filterValue = this.state.filterValue, ownerType = this.props.ownerType) => {
    let data = {};
    for (let property in filterValue) {
      if (property === 'created_at_from' || property === 'created_at_to') {
        data[property] = filterValue[property] ? filterValue[property].format('YYYY-MM-DD') : null;
      } else {
        data[property] = filterValue[property];
      }
    }

    data["is_own"] = ownerType === OwnerType.OWN.value ? 'true' : 'false';

    return data;
  }

  getDayBeforeCount = () => {
    const { type, pageInfo } = this.props;

    let count = 0;

    if (pageInfo && pageInfo.hasOwnProperty('daily_summaries')) {
      if (type === TimelineLabelType.APPOINTMENT.value && pageInfo.daily_summaries.hasOwnProperty("appointment_count")) {
        count = pageInfo.daily_summaries["appointment_count"];
      } else if (type === TimelineLabelType.CLOSE.value && pageInfo.daily_summaries.hasOwnProperty("close_count")) {
        count = pageInfo.daily_summaries["close_count"];
      } else if (type === TimelineLabelType.APPROACH_NG.value && pageInfo.daily_summaries.hasOwnProperty("approach_ng_count")) {
        count = pageInfo.daily_summaries["approach_ng_count"];
      } else if (type === TimelineLabelType.QR_CODE_REACTION.value && pageInfo.daily_summaries.hasOwnProperty("qr_code_reaction_count")) {
        count = pageInfo.daily_summaries["qr_code_reaction_count"];
      } else if (type === TimelineLabelType.NON_CONNECT.value && pageInfo.daily_summaries.hasOwnProperty("non_connect_count")) {
        count = pageInfo.daily_summaries["non_connect_count"];
      } else if (type === TimelineLabelType.DECLINED.value && pageInfo.daily_summaries.hasOwnProperty("declined_count")) {
        count = pageInfo.daily_summaries["declined_count"];
      } else if (type === TimelineLabelType.CONNECT.value && pageInfo.daily_summaries.hasOwnProperty("connect_count")) {
        count = pageInfo.daily_summaries["connect_count"];
      } else if (type === TimelineLabelType.SENT_DOCUMENT.value && pageInfo.daily_summaries.hasOwnProperty("sent_document_count")) {
        count = pageInfo.daily_summaries["sent_document_count"];
      } else if (type === "lead_note" && pageInfo.daily_summaries.hasOwnProperty("lead_note_count")) {
        count = pageInfo.daily_summaries["lead_note_count"];
      } else if (type === TimelineLabelType.APPROACH.value && pageInfo.daily_summaries.hasOwnProperty("approach_count")) {
        count = pageInfo.daily_summaries["approach_count"];
      }
    }

    return count;
  }

  getPersonsCount = () => {
    const { pageInfo, type, isLoading, isDemo } = this.props;

    if (isDemo && type === TimelineLabelType.QR_CODE_REACTION.value) {
      return StatusOverviewAbstractPanel.DEMO_DATA["QR_CODE_REACTION"]["PERSONS_COUNT"];
    }

    if (isDemo && type === "lead_note") {
      return StatusOverviewAbstractPanel.DEMO_DATA["LEAD_NOTE"]["PERSONS_COUNT"];
    }

    if (isLoading) {
      return '- ';
    }

    if (pageInfo && pageInfo.hasOwnProperty('total')) {
      return addCommas(pageInfo.total);
    }

    return '- ';
  }

  getDayBeforeDiffCount = () => {
    const { pageInfo, type, isLoading, isDemo } = this.props;

    if (isDemo && type === TimelineLabelType.QR_CODE_REACTION.value) {
      return "+" + StatusOverviewAbstractPanel.DEMO_DATA["QR_CODE_REACTION"]["DAY_BEFORE_COUNT"];
    }

    if (isDemo && type === "lead_note") {
      return "+" + StatusOverviewAbstractPanel.DEMO_DATA["LEAD_NOTE"]["DAY_BEFORE_COUNT"];
    }

    if (isLoading) {
      return '- ';
    }

    if (pageInfo && pageInfo.hasOwnProperty('total')) {
      const dayBeforeCount = this.getDayBeforeCount();
      const totalCount = pageInfo.total;
      return ((totalCount - dayBeforeCount) > 0 ? "+" : "") + (totalCount - dayBeforeCount);
    }

    return '- ';
  }

  getCorpCount = () => {
    const { pageInfo, type, isLoading, isDemo } = this.props;

    if (isDemo && type === TimelineLabelType.QR_CODE_REACTION.value) {
      return StatusOverviewAbstractPanel.DEMO_DATA["QR_CODE_REACTION"]["CORP_COUNT"];
    }

    if (isDemo && type === "lead_note") {
      return StatusOverviewAbstractPanel.DEMO_DATA["LEAD_NOTE"]["CORP_COUNT"];
    }

    if (isLoading) {
      return '- ';
    }

    if (pageInfo && pageInfo.hasOwnProperty('corporation_count')) {
      return addCommas(pageInfo.corporation_count);
    }

    return '- ';
  }

  render() {
    const { classes } = this.props;
    let color = '#176EFF';
    let background = '#F2F6FF';
    let title;
    let path;
    if (this.props.type === "lead_note") {
      title = DashboardTimelineType.LEAD_NOTE.text;
      path = DashboardTimelineType.LEAD_NOTE.path;
    } else {
      const target = Object.values(TimelineLabelType).find(label => label.value === this.props.type);
      if (target) {
        title = target.text;
        path = target.path;
        color = target.color;
        background = target.backgroundColor;
      }
    }

    return (
      <div className={classes.root}>
        <div className={classes.main}>
          <PanelHeader
            title={title}
            isDemo={this.props.isDemo}
            type={this.props.type}
            dateRanges={DateRanges}
            dateSelected={this.state.dateSelected}
            handleSelectDate={this.handleSelectDate}
            togglePlanDialog={this.props.togglePlanDialog}
          />
          <div
            className={classes.header}
            style={{ color: color, background: background }}>
            <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-between' }}>
              <Typography style={{ fontSize: '32px', color: color }}>
                {this.getPersonsCount()}人
                <span style={{ color: color, marginBottom: 5, fontSize: 13 }}>
                  （前日比  {this.getDayBeforeDiffCount()}）
                </span>
              </Typography>
              <IconButton
                className={classes.circle}
                onClick={() => this.props.isDemo ? this.props.togglePlanDialog() : this.props.goTo('/order-dashboard' + path, { ownerType: this.props.ownerType, dateSelectedValue: this.state.dateSelected.value })}
              >
                <ArrowRight color={color} width={22} height={22} />
              </IconButton>
            </div>
            <Typography variant="body2" style={{ color: color }}>
              企業数: {this.getCorpCount()}社
            </Typography>
          </div>
        </div>
      </div>
    )
  }
}

StatusOverviewAbstractPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  isDemo: PropTypes.bool.isRequired,
  goTo: PropTypes.func.isRequired,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool,
  pageInfo: PropTypes.object,
  getStatus: PropTypes.func.isRequired,
  togglePlanDialog: PropTypes.func.isRequired,
  ownerType: PropTypes.string,
};

StatusOverviewAbstractPanel.DEMO_DATA = {
  "QR_CODE_REACTION": {
    "PERSONS_COUNT": 2,
    "DAY_BEFORE_COUNT": 1,
    "CORP_COUNT": 2,
  },
  "LEAD_NOTE": {
    "PERSONS_COUNT": 5,
    "DAY_BEFORE_COUNT": 2,
    "CORP_COUNT": 3,
  },
};

const mapStateToProps = (state) => {
  return {
    isDemo: state.accountSetting.showDemoData,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(StatusOverviewAbstractPanel));



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/panels/StatusOverviewAbstractPanel.jsx